"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileListCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const tech_1 = require("../../../tech");
const FileUploadModal_1 = require("../FileUploadModal");
const react_1 = require("react");
const FilesItem_1 = __importDefault(require("./FilesItem"));
const Alerts_1 = require("../../../tech/Alerts");
const react_ui_1 = require("@pasport/react-ui");
const FileListCard = ({ hide, isEditMode, dispatchFileUpload, onPhotoDelete, loadImages, strings, children, fileFormat, fetchFile }) => {
    const { addErrorAlert } = (0, Alerts_1.useAlert)();
    const [fileListApiState, invalidateFileList] = (0, tech_1.useApiStateEffect)(async () => {
        if (loadImages)
            return loadImages();
        else
            return Promise.resolve([]);
    });
    const { fetchApiState: deleteFetch, apiState: deleteApiState } = (0, tech_1.useApiState)();
    const [showModal, setShowModal] = (0, react_1.useState)(false);
    const handleSuccess = () => {
        invalidateFileList();
        setShowModal(false);
    };
    (0, tech_1.useApiStateSuccess)(() => {
        invalidateFileList();
    }, [deleteApiState]);
    (0, tech_1.useApiStateError)(() => {
        addErrorAlert({ message: 'Objevila se neočekávaná chyba. Zkuste akci zopakovat později.' });
        invalidateFileList();
    }, [deleteApiState]);
    if (fileListApiState.loading && !hide) {
        return (0, jsx_runtime_1.jsx)("div", { children: "na\u010D\u00EDt\u00E1ni" });
    }
    const handleDelete = async (photo) => {
        if (!onPhotoDelete)
            return;
        deleteFetch(() => onPhotoDelete(photo));
    };
    if (!children && hide)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    const photos = fileListApiState.data || [];
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(react_ui_1.DetailCard, { title: strings.title, actions: isEditMode && !hide
                    ? (0, jsx_runtime_1.jsx)(react_ui_1.Button, { color: 'success', onPress: () => setShowModal(true), children: strings.addButton })
                    : undefined, children: [!hide && ((0, jsx_runtime_1.jsx)("div", { className: "overflow-auto", style: { maxHeight: 300 }, children: photos.length > 0 ? photos.map((photoFile, index) => ((0, jsx_runtime_1.jsx)("div", { className: index !== 0 ? "border-top" : undefined, children: (0, jsx_runtime_1.jsx)(FilesItem_1.default, { photo: photoFile, isEditMode: isEditMode, onDelete: onPhotoDelete ? handleDelete : undefined, strings: strings.deleteItem, fetchFile: fetchFile }) }, photoFile.url))) : ((0, jsx_runtime_1.jsx)("div", { children: strings.noFiles })) })), hide ? children : ((0, jsx_runtime_1.jsx)("div", { className: "pt-3", children: children }))] }), dispatchFileUpload && ((0, jsx_runtime_1.jsx)(FileUploadModal_1.FileUploadModal, { show: showModal, onClose: () => setShowModal(false), dispatchFileUpload: dispatchFileUpload, onSuccess: handleSuccess, strings: strings.uploadItem, fileFormat: fileFormat ?? "application/pdf,image/*" }))] }));
};
exports.FileListCard = FileListCard;
